<template>
  <main class="main-content doc-narrow-content">
    <!-- 页面标题 -->
    <div class="page-header">
      <h1 class="page-title">SDK & Demo</h1>
      <!-- <div class="page-info">
        <span>更新时间：2023-08-18 13:17</span>
        <a href="#" class="document-record">文档记录 ></a>
      </div> -->
    </div>

    <!-- 1. 开放平台服务SDK -->
    <section class="section">
      <h2 class="section-title">SDK</h2>
      <div class="section-content">
        <p class="description">
          为了帮助开发者调用开放接口，银企通™API提供了SDK，当前仅支持Java版本，SDK中封装了签名
          & 验签、HTTP 接口请求等基础功能。
        </p>

        <div class="demo-table-container">
          <table class="demo-table">
            <thead>
              <tr>
                <th width="100px">SDK 语言</th>
                <th width="100px">版本</th>
                <th width="200px">下载连接</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>JAVA版</td>
                <td>JDK 1.8</td>
                <td>
                  <div class="flex items-center gap-2">
                    <a
                      href="#"
                      class="download-link"
                      @click="handleSdkDownload($event, 'java')"
                    >
                      点击下载
                    </a>
                    <img
                      :src="downloadIcon"
                      alt="下载图标"
                      class="w-4 h-4"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <!-- 2. 当面付 Demo -->
    <section class="section">
      <h2 class="section-title">Demo</h2>
      <div class="section-content">
        <p class="description">请根据开发语言下载对应的 Demo。</p>

        <div class="demo-table-container">
          <table class="demo-table">
            <thead>
              <tr>
                <th width="100px">Demo版本</th>
                <th width="100px">运行环境</th>
                <th width="200px">下载链接</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>JAVA版</td>
                <td>JDK 1.8</td>
                <td>
                  <div class="flex items-center gap-2">
                    <a
                      href="#"
                      class="download-link"
                      @click="handleDemoDownload($event, 'java')"
                      >点击下载</a
                    >
                    <img
                      :src="downloadIcon"
                      alt="下载图标"
                      class="w-4 h-4"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <!-- 3. 运行说明 -->
    <section class="section">
      <h2 class="section-title">运行说明</h2>
      <div class="section-content">
        <p class="description">
          1、下载并解压sdk-demo.zip 文件后，可以得到一个完整的demo示例应用程序，
        </p>
        <p class="description">
          2、将libs文件夹下的
          nextbankapi-sdk-v2-1.0.0.jar文件引入到你要使用的应用程序中，
        </p>
        <p class="description">
          3、首先确认已安装JDK和Maven/Gradle，确保项目结构完整，特别是libs目录下有nextbankapi-sdk-v2-1.0.0.jar文件
        </p>
        <p class="description">4、选择要运行的示例项目中有四个示例可供选择</p>
        <p class="description">5、编辑相应的示例文件，修改以下配置：</p>
        <div class="api-details">
          <pre>

          NextBankApiConfig config = new NextBankApiConfig.Builder()
            .baseUrl("https://qa.nexbankapi.com") // 替换为实际的API地址
            .appId("your-app-id") // 替换为实际的App ID 
            .apiKey("your-api-key") // 替换为实际的API Key 
            .timeout(Duration.ofSeconds(30))
            .build();
        </pre
          >
        </div>
        <p class="description">
          6、按照对应的示例代码，按照想要调用的接口，创建对应的request请求即可。
        </p>
      </div>
    </section>
  </main>
</template>

<script setup lang="ts">
import { useCodeHighlight } from "@/composables/useCodeHighlight";
import downloadIcon from "@/assets/download.svg";

// 使用代码高亮功能
useCodeHighlight(".api-details pre");

// 定义资源下载链接 (OSS链接，后续可以替换为实际的链接)
const sdkDownloadLinks = {
  java: "https://release.xencio.com/nexbank/sdk/nextbankapi-sdk-v2-1.0.0.jar", // 示例OSS链接
  // 可以添加其他语言的链接
};

const demoDownloadLinks = {
  java: "https://release.xencio.com/nexbank/demo/sdk-demo.zip", // 示例OSS链接
  // 可以添加其他语言的链接
};

// 处理SDK下载
const handleSdkDownload = (event: Event, language: string) => {
  event.preventDefault();
  const url = sdkDownloadLinks[language as keyof typeof sdkDownloadLinks];
  if (url) {
    window.open(url, "_blank");
  } else {
    alert("暂未提供该语言版本的SDK下载");
  }
};

// 处理Demo下载
const handleDemoDownload = (event: Event, language: string) => {
  event.preventDefault();
  const url = demoDownloadLinks[language as keyof typeof demoDownloadLinks];
  if (url) {
    window.open(url, "_blank");
  } else {
    alert("暂未提供该语言版本的Demo下载");
  }
};
</script>

<style scoped>
/* .main-content {
  flex: 1;
  margin-left: var(--sidebar-width);
  padding: 2rem;
  margin-top: var(--header-height);
} */
.sdk-demo-page {
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  /* background-color: #f8f9fa; */
}

.page-header {
  margin-bottom: 30px;
}

.page-title {
  font-size: 24px;
  font-weight: bold;
  color: #000;
  margin-bottom: 10px;
}

.page-info {
  display: flex;
  align-items: center;
  gap: 15px;
  font-size: 14px;
  color: #666;
}

.document-record {
  color: #1677ff;
  text-decoration: none;
}

.document-record:hover {
  text-decoration: underline;
}

.section {
  background: #fff;
  /* border: 1px solid #d9d9d9; */
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 30px;
  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06); */
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin-bottom: 15px;
}

.section-content {
  color: #333;
}

.description {
  margin-bottom: 20px;
  line-height: 1.8;
}

.demo-table-container {
  margin-top: 20px;
}

.demo-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e8e8e8;
}

.demo-table th,
.demo-table td {
  padding: 12px;
  text-align: left;
  border: 1px solid #e8e8e8;
}

.demo-table th {
  background-color: #fafafa;
  font-weight: bold;
  color: #333;
}

.demo-table tr:hover {
  background-color: #f5f5f5;
}

.download-link {
  color: #1677ff;
  text-decoration: none;
}

.note {
  color: #ff4d4f;
  margin-top: 15px;
  font-size: 0.9em;
}
.api-details {
  background-color: var(--code-bg);
  color: var(--code-color);
  border-radius: 8px;
  padding: 1rem;
  font-size: 0.85rem;
  overflow-x: auto;
  margin-bottom: 1rem;
  line-height: 1.5;
}

.api-details pre {
  margin: 0;
  white-space: pre-wrap;
}
</style>
